export default __webpack_public_path__ + "static/media/owner.008d0299.svg";